<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <a href="#" aria-current="page" @click="showDetails = !showDetails">
              <span>{{productId}}</span> &nbsp;-&nbsp;
              <span>{{product && product.model}}</span>
              <span class="icon">
                <i class="fas" :class="{'fa-chevron-up': showDetails, 'fa-chevron-down': !showDetails}"></i>
              </span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="tabs is-toggle">
        <ul>
          <li :class="{'is-active': country == 'us'}">
            <router-link :to="'/sale-speed/us/' + productId">
              <span>US</span>
            </router-link>
          </li>
          <li :class="{'is-active': country == 'canada'}">
            <router-link :to="'/sale-speed/canada/' + productId">
              <span>Canada</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="mt-3">
        <div v-if="waiting || !product || !speeds">
          <span class="icon is-medium is-size-4">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </div>
        <div v-else>
          <div v-show="showDetails">
            <div class="field mt-3">
              <label class="label">Name</label>
              <div class="control">
                <input class="input" type="text" v-model="product.name" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Model</label>
              <div class="control">
                <input class="input" type="text" v-model="product.model" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Brand</label>
              <div class="control">
                <input class="input" type="text" v-model="product.brand" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">NS Sku</label>
              <div class="control">
                <input class="input" type="text" v-model="product.nsSku" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">NS Id Index</label>
              <div class="control">
                <input class="input" type="text" v-model="product.nsIdIndex" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">NS Name</label>
              <div class="control">
                <input class="input" type="text" v-model="product.nsName" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Class</label>
              <div class="control">
                <input class="input" type="text" v-model="product.productClass" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Landed Cost Params</label>
              <div class="control">
                <input class="input" type="text" v-model="product.landedCostParams" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Forecast Params</label>
              <div class="control">
                <input class="input" type="text" v-model="product.forecastParams" readonly>
              </div>
            </div>
            <div class="field mt-3">
              <label class="label">Sales Data</label>
              <div class="control">
                <input class="input" type="text" v-model="product.salesData" readonly>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h1 class="title is-5 mt-6">Sale Speeds Chart</h1>
            </div>
            <div class="columns">
              <div class="column">
                <div class="chart-container">
                  <v-chart autoresize :option="speedChartOption" :ref="'speed-chart'" />
                </div>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h1 class="title is-5 mt-6">Speeds Table</h1>
            </div>
            <table class="table is-fullwidth is-striped" v-if="true">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th class="num-cell">Speed</th>
                  <th class="num-cell">
                    <span>Speeds / Weights</span><br/>
                    <span class="is-size-7 has-text-grey">year, month, two weeks</span>
                  </th>
                  <th class="num-cell">
                    <span>Sales</span><br/>
                    <span class="is-size-7 has-text-grey">year, month, two weeks</span>
                  </th>
                  <th class="num-cell">
                    <span>Inventories</span><br/>
                    <span class="is-size-7 has-text-grey">year, month, two weeks</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in showingDates" :key="'row-date-' + i">
                  <td>{{i + 1}}</td>
                  <td class="price-date">{{d}}</td>
                  <td class="num-cell" v-if="country=='us'">{{formatSpeed(dateSpeedMap[d].usSpeed)}}</td>
                  <td class="num-cell" v-if="country=='canada'">{{formatSpeed(dateSpeedMap[d].canadaSpeed)}}</td>
                  <td class="num-cell" v-if="country=='us'">
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedContext">
                      <span>
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedContext.speeds.year)}}</span>,
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedContext.speeds.month)}}</span>,
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedContext.speeds.week)}}</span>
                      </span>
                      <br/>
                      <span class="is-size-7 has-text-grey">
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.weights.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.weights.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.weights.week}}</span>
                      </span>
                    </span>
                  </td>
                  <td class="num-cell" v-if="country=='canada'">{{formatSpeed(dateSpeedMap[d].canadaSpeed)}}
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedCanadaContext">
                      <span>
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedCanadaContext.speeds.year)}}</span>,
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedCanadaContext.speeds.month)}}</span>,
                        <span>{{formatSpeed(dateSpeedMap[d].speedContext.saleSpeedCanadaContext.speeds.week)}}</span>
                      </span>
                      <br/>
                      <span class="is-size-7 has-text-grey">
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.weights.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.weights.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.weights.week}}</span>
                      </span>
                    </span>
                  </td>
                  <td class="num-cell" v-if="country=='us'">
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedContext">
                      <span>
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.sales.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.sales.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.sales.week}}</span>
                      </span>
                    </span>
                  </td>
                  <td class="num-cell" v-if="country=='canada'">
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedCanadaContext">
                      <span>
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.sales.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.sales.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.sales.week}}</span>
                      </span>
                    </span>
                  </td>
                  <td class="num-cell" v-if="country=='us'">
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedContext">
                      <span>
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.inventories.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.inventories.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedContext.inventories.week}}</span>
                      </span>
                    </span>
                  </td>
                  <td class="num-cell" v-if="country=='canada'">
                    <span v-if="dateSpeedMap[d].speedContext.saleSpeedCanadaContext">
                      <span>
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.inventories.year}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.inventories.month}}</span>,
                        <span>{{dateSpeedMap[d].speedContext.saleSpeedCanadaContext.inventories.week}}</span>
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <a class="button" @click="showAll = !showAll">Toggle all (might take long time to show all)</a>
          </div>
        </div>
      </div>
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat'
import { saveAs } from 'file-saver'
import { urlToHttpOptions } from 'url'


export default {
  name: 'SaleSpeed',
  data () {
    return {
      error: '',
      waiting: false,
      showDetails: false,
      product: null,
      speeds: null,
      exporting: false,
      commonOption: {
        legend: {
          data: ['Sale speed', 'Sales', 'Inventory'],
          top: 30
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {}
          }
        },
        yAxis: {
          type: 'value'
        }
      },
      showAll: false,
      dateSaleMap: {},
      dateSaleCanadaMap: {},
      dateInventoryMap: {},
      dateInventoryCanadaMap: {},
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    productId () {
      return this.$route.params.productId
    },
    country () {
      return this.$route.params.country
    },
    dateSpeedMap () {
      if (!this.speeds) {
        return {}
      }
      var dateSpeedMap = {}
      for (var s of this.speeds) {
        dateSpeedMap[s.date] = s
      }
      return dateSpeedMap
    },
    dates () {
      if (!this.dateSpeedMap) {
        return []
      }
      var dates = Object.keys(this.dateSpeedMap)
      dates = Array.from(new Set(dates))
      return dates.sort((a, b) => b.localeCompare(a))
    },
    showingDates () {
      if (this.showAll) {
        return this.dates
      }
      return this.dates.slice(0, 10)
    },
    xAxis () {
      var option = {type: 'category'}
      if (!this.dates.length) {
        return option
      }
      var firstDate = new Date(this.dates[this.dates.length - 1])
      var lastDate = new Date(this.dates[0])
      var dates = []
      var date = firstDate
      while (date.getTime() <= lastDate.getTime()) {
        dates.push(date.toISOString().substring(0, 10))
        date = new Date(date.getTime() + 24 * 3600 * 1000)
      }
      option.data = dates
      return option
    },
    yAxis () {
      return [
        {
          type: 'value',
          name: 'Sale speed',
          position: 'left',
          alignTicks: true,
        },
        {
          type: 'value',
          name: 'Sales',
          position: 'right',
          alignTicks: true,
        },
        {
          type: 'value',
          name: 'Inventory',
          position: 'right',
          alignTicks: true,
          offset: 60,
        },
      ]
    },
    speedSerie () {
      var vm = this
      var speeds = []
      if (vm.xAxis.data) {
        vm.xAxis.data.forEach((date) => {
          var s = vm.dateSpeedMap[date]
          if (!s) {
            speeds.push(null)
          } else {
            var speed = vm.country == 'us' ? s.usSpeed : s.canadaSpeed
            if (speed || speed == 0) {
              speeds.push(speed)
            } else {
              speeds.push(null)
            }
          }
        })
      }
      var serie = {
        name: 'Sale speed',
        data: speeds,
        type: 'line',
        yAxisIndex: 0,
      }
      return serie
    },
    saleSerie () {
      var vm = this
      var sales = []
      if (vm.xAxis.data) {
        vm.xAxis.data.forEach((date) => {
          var s = vm.country == 'us' ? vm.dateSaleMap[date] : vm.dateSaleCanadaMap[date]
          if (!s) {
            sales.push(null)
          } else {
            sales.push(s)
          }
        })
      }
      var serie = {
        name: 'Sales',
        data: sales,
        type: 'bar',
        yAxisIndex: 1,
      }
      return serie
    },
    inventorySerie () {
      var vm = this
      var inventories = []
      if (vm.xAxis.data) {
        vm.xAxis.data.forEach((date) => {
          var i = vm.country == 'us' ? vm.dateInventoryMap[date] : vm.dateInventoryCanadaMap[date]
          if (!i) {
            inventories.push(null)
          } else {
            inventories.push(i)
          }
        })
      }
      var serie = {
        name: 'Inventory',
        data: inventories,
        type: 'bar',
        yAxisIndex: 2,
      }
      return serie
    },
    speedChartOption () {
      var option = {...this.commonOption}
      option.title = {text: 'Sale speed', left: 'center'}
      option.xAxis = this.xAxis
      option.series = [this.speedSerie, this.saleSerie, this.inventorySerie]
      option.yAxis = this.yAxis
      option.dataZoom = [
        {start: 0, end: 100},
        {type: 'inside'}
      ]
      return option
    },
  },
  watch: {
    productId: function (val) {
      this.getSpeeds()
    },
  },
  methods: {
    getSpeeds () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-sale-speed-by-product-id/' + this.productId + '/').then(resp => {
        this.product = resp.body.product
        this.speeds = resp.body.saleSpeeds
        this.getInventories()
        this.getSales()
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    formatSpeed (value) {
      if (!value) {
        if (value == 0) {
          return '0'
        }
        return ''
      }
      return value.toLocaleString('en-US', {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
        useGrouping: false
      })
    },
    getInventories () {
      var itemId = this.product.nsIdIndex
      this.$http.get(this.server + '/myapp/get-inventory-by-ns-id-index/' + itemId + '/').then(resp => {
        var dateInventoryMap = {}
        var dateInventoryCanadaMap = {}
        for (var i of resp.body) {
          var date = i.date
          if (i.inventory) {
            if (!dateInventoryMap[date]) {
              dateInventoryMap[date] = i.inventory
            }
          }
          if (i.onInventory) {
            if (!dateInventoryCanadaMap[date]) {
              dateInventoryCanadaMap[date] = i.onInventory
            }
          }
        }
        this.dateInventoryMap = dateInventoryMap
        this.dateInventoryCanadaMap = dateInventoryCanadaMap
      }, err => {
        this.error = err.body
      })
    },
    getSales () {
      var itemId = this.product.nsIdIndex
      this.$http.get(this.server + '/myapp/get-sales-by-ns-id-index/' + itemId + '/').then(resp => {
        var dateSaleMap = {}
        var dateSaleCanadaMap = {}
        for (var s of resp.body) {
          var date = s.tranDate
          if (s.subsidiaryId == '2') {
            if (!dateSaleCanadaMap[date]) {
              dateSaleCanadaMap[date] = 0
            }
            dateSaleCanadaMap[date] += s.quantity
          } else {
            if (!dateSaleMap[date]) {
              dateSaleMap[date] = 0
            }
            dateSaleMap[date] += s.quantity
          }
        }
        this.dateSaleMap = dateSaleMap
        this.dateSaleCanadaMap = dateSaleCanadaMap
      }, err => {
        this.error = err.body
      })
    },
  },
  mounted () {
    this.$nextTick(function(){
      this.getSpeeds()
    })
  },
}
</script>

<style scoped>
.price-date {
  white-space: nowrap;
}
.num-cell {
  text-align: right !important;
}
.chart-container {
  height: 500px;
  width: 100%;
}
</style>
